import { useCallback, useEffect, useMemo, useState, type ReactNode } from "react";
import { applyTheme, getInitialTheme, storeTheme, type Theme } from "../lib/theme";
import { ThemeContext } from "../lib/theme-context";

// Holds the active theme in React state and mirrors it onto <html>. The
// initial value matches the pre-paint script in index.html so hydration
// doesn't cause a flash.
export function ThemeProvider({ children }: { children: ReactNode }) {
  const [theme, setThemeState] = useState<Theme>(getInitialTheme);

  useEffect(() => {
    applyTheme(theme);
  }, [theme]);

  const setTheme = useCallback((next: Theme) => {
    storeTheme(next);
    setThemeState(next);
  }, []);

  const toggle = useCallback(() => {
    setThemeState((prev) => {
      const next: Theme = prev === "dark" ? "light" : "dark";
      storeTheme(next);
      return next;
    });
  }, []);

  const value = useMemo(() => ({ theme, setTheme, toggle }), [theme, setTheme, toggle]);

  return <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>;
}
